"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    stockTaking: 'Inventering' || 'stockTaking',
    id: 'Identitet' || 'id',
    stockTakingNumber: 'Avräkning' || 'stockTakingNumber',
    endCustomerInInventory: 'Bunden till kund' || 'end-customer-in-inventory',
    stockTakingState: 'Status' || 'stockTakingState',
    stockTakingStates: {
        created: 'Skapad' || 'created',
        locationsAssigned: 'Artiklar placerade' || 'locationsAssigned',
        countStarted: 'Inventering påbörjad' || 'countStarted',
        stocksTaken: 'Inventarier räknade' || 'stocksTaken',
        pricesSet: 'Priser angivna' || 'pricesSet',
        completed: 'Klar' || 'completed',
    },
    completedDate: 'Datum för klarmarkering' || 'completedDate',
    totalValue: 'Räknat lagervärde' || 'totalValue',
    stockTakingRows: {
        id: 'Identitet' || 'id',
        location: 'Plats' || 'location',
        articleInInventory: 'Artikel' || 'article-in-inventory',
        previousQuantity: 'Föregående inventeringsmängd' || 'previousQuantity',
        purchasedQuantity: 'Köpt mängd sedan föregående inventering' || 'purchasedQuantity',
        countedQuantity: 'Inventerad mängd' || 'countedQuantity',
        latestPurchasePrice: 'Senaste inköpspris' || 'latestPurchasePrice',
        currency: 'Valuta' || 'currency',
        total: 'Lagervärde' || 'total',
    },
};
